var _rect, _g, _defs;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#fff",
    rx: 20
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#37a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7F96FF",
    d: "m14.852 32.069 2.667 1.281.777.376-4.091-17.931h-3.068zm-6.9-3.328 3.457 1.658-3.34-14.604H5zm14.319-4.518-1.93-8.428h-3.068l3.457 15.147z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#002DFF",
    d: "m25.909 31.628-2.991 1.438L28.64 8l2.072 2.59zm5.981-2.887-2.99 1.437 3.883-16.985 2.072 2.602zM13.286 5.411l-2.072 2.59H23.32l-.595 2.59H9.143L7.07 13.204h15.057l-.595 2.59H5l.596 2.59H20.95L17.52 33.35l2.394 1.152 6.655-29.09z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "37a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 5h30v30H5z"
  })))));
});
const SvgCin7 = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCin7);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IndoaXRlIi8+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF8xNDMwXzM1Mzk1KSI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTQuODUyMyAzMi4wNjg3TDE3LjUxOTMgMzMuMzUwNUwxOC4yOTYxIDMzLjcyNTlMMTQuMjA1IDE1Ljc5NDlIMTEuMTM2N0wxNC44NTIzIDMyLjA2ODdaTTcuOTUxODEgMjguNzQxNUwxMS40MDg1IDMwLjM5ODZMOC4wNjgzMyAxNS43OTQ5SDVMNy45NTE4MSAyOC43NDE1Wk0yMi4yNzA3IDI0LjIyMzFMMjAuMzQxNyAxNS43OTQ5SDE3LjI3MzNMMjAuNzMwMSAzMC45NDI0TDIyLjI3MDcgMjQuMjIzMVoiIGZpbGw9IiM3Rjk2RkYiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yNS45MDg3IDMxLjYyODRMMjIuOTE4IDMzLjA2NTVMMjguNjQwNCA4LjAwMDkzTDMwLjcxMTkgMTAuNTkwMkwyNS45MDg3IDMxLjYyODRaTTMxLjg5IDI4Ljc0MTNMMjguODk5MyAzMC4xNzg0TDMyLjc4MzMgMTMuMTkyNUwzNC44NTQ4IDE1Ljc5NDhMMzEuODkgMjguNzQxM1pNMTMuMjg1OCA1LjQxMTYyTDExLjIxNDMgOC4wMDA5M0gyMy4zMTk0TDIyLjcyMzggMTAuNTkwMkg5LjE0MjlMNy4wNzE0NSAxMy4yMDU0SDIyLjEyODNMMjEuNTMyOCAxNS43OTQ4SDVMNS41OTU1NCAxOC4zODQxSDIwLjk1MDJMMTcuNTE5MyAzMy4zNTAzTDE5LjkxNDQgMzQuNTAyNUwyNi41NjkgNS40MTE2MkgxMy4yODU4WiIgZmlsbD0iIzAwMkRGRiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzE0MzBfMzUzOTUiPgo8cmVjdCB3aWR0aD0iMzAiIGhlaWdodD0iMzAiIGZpbGw9IndoaXRlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSg1IDUpIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";